import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, Checkbox, Label, Box, Flex } from 'pcln-design-system'

const FlexDatesCheckbox = styled(Flex)`
  flex-wrap: nowrap;
`

const LabelText = styled(Box)`
  display: inline-block;
  margin-left: 5px;
  vertical-align: middle;
`

const LabelFlex = styled(Label)`
  display: flex;
  align-items: center;

  ${(props) => props.theme.mediaQueries.sm} {
    & span {
      white-space: nowrap;
    }
  }
`

export default function FlexDatesOptionsCheckbox(props) {
  const {
    isFlexDates,
    tripType,
    isDirty,
    setDirtyFlag,
    toggleFlexDates,
    setCheckboxRef,
    logFlexibleDatesEvent,
  } = props

  const flexibleDatesText =
    tripType === 'OW' ? 'Depart 1 day before or after' : 'Depart/Return 1 day before or after'

  function updateFlexDates() {
    if (!isDirty) {
      setDirtyFlag()
    }
    toggleFlexDates(!isFlexDates)
    if (logFlexibleDatesEvent) {
      logFlexibleDatesEvent()
    }
  }

  return (
    <FlexDatesCheckbox data-autobot-element='csh-flexdates-checkbox' alignItems='center'>
      <LabelFlex htmlFor='cshFlexibleDatesOptions' color='border.base'>
        <Checkbox
          defaultChecked={isFlexDates}
          size={25}
          id='cshFlexibleDatesOptions'
          onClick={updateFlexDates}
          ref={setCheckboxRef}
        />
        <LabelText data-autobot-element='csh-flexdates-label-text' htmlFor='cshFlexibleDatesOptions'>
          <Text.span fontSize={1} color='text.base' regular>
            Flexible Dates{' '}
          </Text.span>
          <Text.span fontSize={0} color='text.base' regular className={'flexible-dates-text'}>
            ({flexibleDatesText})
          </Text.span>
        </LabelText>
      </LabelFlex>
    </FlexDatesCheckbox>
  )
}

FlexDatesOptionsCheckbox.propTypes = {
  isFlexDates: PropTypes.bool,
  tripType: PropTypes.string,
  setDirtyFlag: PropTypes.func.isRequired,
  toggleFlexDates: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  setCheckboxRef: PropTypes.func,
  logFlexibleDatesEvent: PropTypes.func,
}
